// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import Checkbox from './../../../components/checkbox/Checkbox';
import { modelAttributesDictionary } from './../../../utilities/modelDictionary';
import { renderAttributeInfo } from './../../../utilities/renderAttributes.jsx';
import { translate } from "react-i18next";

import type { ModelMetaData } from './../../../types/model'

type State = {
}

type Props = {
    model: ModelMetaData,
    visible: boolean,
    axiosInstance: Object,
    t: (s: string) => string,
}

const DetailsWrapper = styled.div`
    max-height: ${props => props.visible ? '450px' : '0px'};
    border-bottom: 1.5px solid rgba(128, 128, 128, 0.1);
    transition: max-height 0.5s;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    >p{
        margin: 5px;
        display: flex;
        justify-content: space-between;
        >span{
            color: grey;
        }
    }
`;

const DetailRow = styled.div`
    p{
        margin: 4px;
    }
`;

const AttributeName = styled.p`
    color: #2d2d2d;
    font-size: 14px;
    font-weight: 400;
`;

const AttributeValue = styled.p`
    color: #265a9c;
    font-size: 14px;
    font-weight: 700;
`;

const ModelLink = styled.a`
    color: #265a9c;
    font-size: 12px;
    font-weight: 700;
    overflow-wrap: break-word;
    word-wrap: break-word;
`;

const LinkRow = styled.div`
    margin: 0 5px 0 5px;
`;

export class ModelDetails extends React.Component<Props, State> {
    render() {
        const { toggleModelSelection, model, selected, visible, t, } = this.props;
        return (
            <DetailsWrapper visible={visible}>
                <Checkbox
                    style={{
                        position: 'absolute',
                        right: '5px',
                        top: '0',
                        padding: '5px',
                        display: 'block',
                    }}
                    checked={selected}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleModelSelection(model)
                    }}
                />
                {Object.keys(model)
                    .filter(attribute => {
                        return modelAttributesDictionary[attribute].visible;
                    })
                    .map(attribute => {
                        return (
                            <DetailRow key={`model_${model.id}_${attribute}`}>                           
                                <AttributeName>
                                    {`${t(modelAttributesDictionary[attribute].header)}: `}
                                </AttributeName>
                                {attribute === 'url'
                                    ? <LinkRow><ModelLink href={model[attribute]}>{model[attribute]}</ModelLink></LinkRow>
                                    : <AttributeValue>
                                        {
                                            renderAttributeInfo(
                                                modelAttributesDictionary[attribute],
                                                model[attribute],
                                                t
                                            )
                                        }
                                    </AttributeValue>
                                }
                            </DetailRow>
                        )
                    })}
            </DetailsWrapper>
        )
    }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ModelDetails));


// WEBPACK FOOTER //
// ./src/containers/content/rightPanelContent/ModelDetails.jsx